import { List, Map } from "immutable";
import { none, some, Option, loadingAsyncState, unloadedAsyncState, Pair, nothing, Action, Widget } from "widgets-for-react";
import { CustomRouteParams } from "../../../cms/router/type.gen";
import { PageTemplateState } from "../../../cms/state/types.gen";
import { PublicSiteState } from "../../../public_site.main.mod";
import { CustomBlock } from "../../../wordpress/types_and_parser/custom_blocks.mod";
import { Block } from "../../../wordpress/types_and_parser/standard_blocks.gen";
import { get_page } from "../../app.api";
import { InitPagesStates, PublicSite_CustomPageData } from "../../application.mod";
import { CustomBlockData } from "../../blocks/custom_blocks/types.mod";
import { blocks_renderer } from "../../blocks/renderer.mod";
import { ExtraImages } from "../../utils/extra_images.mod";
import { CustomPagesState, PublicSiteCustomRoutes } from "../types.mod";
import { get_stories_overview, get_story_taxonomies } from "./Fc150Years.api";
import { Fc150YearsPages, HomeState, StoriesOverviewState, StoryDetailState, TransitionObject, zeroHomeState, zeroStoriesOverviewState, zeroStoryDetailState } from "./Fc150Years.types";
import { homeWidget } from "./widgets/HomeWidget";
import { storiesOverviewWidget } from "./widgets/StoriesOverviewWidget";
import { storyDetailWidget } from "./widgets/StoryDetailWidget";

export const zero150YearsMainState = (): CustomPagesState['Fc150YearsMainPage'] => ({
  lang: "en",
  current_page: 'transition-page',
  homeState: zeroHomeState(),
  storiesOverviewState: zeroStoriesOverviewState(),
  storyDetailState: zeroStoryDetailState(),
  transition: {
    animationState: 'wave-moving-up',
    from: none(),
    to: {
      current_page: '404',
      homeState: zeroHomeState(),
      storiesOverviewState: zeroStoriesOverviewState(),
      storyDetailState: zeroStoryDetailState(),
      state: InitPagesStates(blocks_renderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>())
    },
    animationTime: 1600,
    kind: 'transition',
  },
  state: InitPagesStates(blocks_renderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>()),
  first_load: true,
  taxonomiesLoader: unloadedAsyncState(),
  pagesloader: unloadedAsyncState(),
  storiesLoader: List()
})

const routeHasChanged = (old_rotue: CustomRouteParams<CustomPagesState, PublicSiteCustomRoutes>, new_route: CustomRouteParams<CustomPagesState, PublicSiteCustomRoutes>): boolean =>
  (old_rotue.kind != new_route.kind) ||
  (old_rotue.kind == 'Fc150YearsMainPage' && new_route.kind == 'Fc150YearsMainPage' && old_rotue.overview_page_title != new_route.overview_page_title) ||
  (old_rotue.kind == 'Fc150YearsMainPage' && new_route.kind == 'Fc150YearsMainPage' && old_rotue.taxonomy != new_route.taxonomy) ||
  (old_rotue.kind == 'Fc150YearsMainPage' && new_route.kind == 'Fc150YearsMainPage' && old_rotue.story_title != new_route.story_title) ||
  (old_rotue.kind == 'Fc150YearsMainPage' && new_route.kind == 'Fc150YearsMainPage' && old_rotue.lang != new_route.lang)



export const makeTransition = (s0: PublicSiteState, old_route: CustomRouteParams<CustomPagesState, PublicSiteCustomRoutes>, new_route: CustomRouteParams<CustomPagesState, PublicSiteCustomRoutes>): PublicSiteState => {

  let animationTime = 1600

  // This case will never happen
  if (new_route.kind != 'Fc150YearsMainPage') return s0

  let get_from_page = (r: CustomRouteParams<CustomPagesState, PublicSiteCustomRoutes>): Option<TransitionObject> =>
    r.kind != 'Fc150YearsMainPage' ? none() : some({
      current_page: r.overview_page_title && r.story_title ? 'story-detail-page' : r.overview_page_title ? 'stories-overview-page' : 'homepage',
      homeState: s0.Fc150YearsMainPage.homeState,
      storiesOverviewState: s0.Fc150YearsMainPage.storiesOverviewState,
      storyDetailState: s0.Fc150YearsMainPage.storyDetailState,
      state: InitPagesStates(blocks_renderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>())
    })


  let current_page: Fc150YearsPages = "404"

  if (!new_route.overview_page_title && !new_route.story_title) {
    current_page = "homepage"
  }
  else if (new_route.overview_page_title && !new_route.story_title) {
    current_page = "stories-overview-page"
  }
  else if (new_route.overview_page_title && new_route.story_title) {
    current_page = "story-detail-page"
  }

  let homeState: HomeState = {
    kind: 'home',
    splashState: old_route.kind == '404' ? 'show' : 'no-show'
  }

  let storiesOverviewState: StoriesOverviewState = {
    kind: 'stories-overview',
    title: new_route.overview_page_title,
    isAbout: new_route.overview_page_title &&
      (
        (new_route.overview_page_title == 'about' && new_route.lang == 'en') ||
        (new_route.overview_page_title == 'over-ons' && new_route.lang == 'nl') ||
        (new_route.overview_page_title == 'uber-uns' && new_route.lang == 'de')
      )
      ? true : false
  }

  let storyDetailState: StoryDetailState = {
    kind: 'story-detail',
    overview_title: new_route.overview_page_title,
    title: new_route.story_title,
  }

  let isHomePageFirstTime = old_route.kind == '404' && new_route.overview_page_title == new_route.story_title


  let state_loader: PageTemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData, PublicSiteState> = {
    ...s0.Fc150YearsMainPage.state,
    page: {
      ...s0.Fc150YearsMainPage.state.page,
      blocks: Map(),
      page: get_page(("/" + ((new_route.story_title && new_route.overview_page_title) ? `stories/${new_route.story_title}` : (new_route.overview_page_title || ""))), [])
    }
  }
  return ({
    ...s0,
    Fc150YearsMainPage: {
      ...s0.Fc150YearsMainPage,
      lang: new_route.lang,
      first_load: false,
      current_page: isHomePageFirstTime ? 'homepage' : 'transition-page',
      homeState: isHomePageFirstTime ? homeState : s0.Fc150YearsMainPage.homeState,
      transition: {
        kind: 'transition',
        animationState: old_route.kind == "404" ? 'wave-up' : 'about-to-move-up',
        from: get_from_page(old_route),
        to: {
          current_page: current_page,
          storiesOverviewState,
          storyDetailState,
          homeState,
          state: state_loader,
        },
        animationTime
      },
      state: isHomePageFirstTime || s0.Fc150YearsMainPage.first_load ? state_loader : s0.Fc150YearsMainPage.state,
      taxonomiesLoader: s0.Fc150YearsMainPage.taxonomiesLoader.kind != 'loaded' ? loadingAsyncState(() => get_story_taxonomies(new_route.lang)) : s0.Fc150YearsMainPage.taxonomiesLoader,
      storiesLoader: (new_route.overview_page_title && new_route.taxonomy && routeHasChanged(old_route, new_route)) ?
        List([loadingAsyncState(() => get_stories_overview(new_route.lang, new_route.taxonomy, 1)) ])
        : routeHasChanged(old_route, new_route) ?
          List() 
          : s0.Fc150YearsMainPage.storiesLoader,
    }
  })
}


const mediaReducedMotionCheck = window.matchMedia('(prefers-reduced-motion: reduce)');
// export let enableReducedMotion: boolean = true; // TODO: ENABLE THIS LINE ON DEVELOP AND LINES BELOW FOR PRODUCTION / AND MAYBE SOMETHING WITH SAVING IT IN THE STATE
export let enableReducedMotion: boolean = mediaReducedMotionCheck.matches;
mediaReducedMotionCheck.addEventListener('change', () => {
  enableReducedMotion = mediaReducedMotionCheck.matches;
});

const mediaHoverCheck = window.matchMedia('(hover: hover)');
// export let enableHoverMotion: boolean = true; // TODO: ENABLE THIS LINE ON DEVELOP AND LINES BELOW FOR PRODUCTION / AND MAYBE SOMETHING WITH SAVING IT IN THE STATE
export let enableHoverMotion: boolean = mediaHoverCheck.matches;
mediaHoverCheck.addEventListener('change', () => {
  enableHoverMotion = mediaHoverCheck.matches;
});


export let renderTransition = (r: Pair<CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>, CustomPagesState["Fc150YearsMainPage"]>, t: TransitionObject, s0: CustomPagesState["Fc150YearsMainPage"]): Widget<Action<CustomPagesState['Fc150YearsMainPage']>> => {
  if (t.current_page == 'homepage') return homeWidget(r)({ ...s0, homeState: t.homeState })
  if (t.current_page == 'stories-overview-page') return storiesOverviewWidget(r)({ ...s0, storiesOverviewState: t.storiesOverviewState })
  if (t.current_page == 'story-detail-page') return storyDetailWidget(r)({ ...s0, storyDetailState: t.storyDetailState })
  return nothing()
}